export function normalizeInviteCodeInput(value) {
  return (value || '').trim().toUpperCase().replace(/\s+/g, '');
}

export function joinByCodeSuccessMessage(data) {
  if (data?.message) return data.message;
  if (data?.status === 'already_member') {
    return `You’re already in ${data?.club_name || 'this club'}.`;
  }
  return `Welcome to ${data?.club_name || 'your new club'}!`;
}

/** Toast copy for post-redeem feedback (survives navigation). */
export function joinByCodeToastContent(data) {
  if (data?.status === 'already_member') {
    return {
      title: 'Already a member',
      body:
        data?.message ||
        `You’re already in ${data?.club_name || 'this club'}. Taking you there now.`,
      variant: 'info',
    };
  }
  return {
    title: 'You’re in',
    body: joinByCodeSuccessMessage(data),
    variant: 'success',
  };
}

export function joinByCodeErrorMessage(err) {
  const data = err?.response?.data || {};
  if (typeof data.error === 'string' && data.error.trim()) return data.error;
  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
  return 'We couldn’t join that club. Check the code and try again.';
}
